import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {OKTA_CONFIG, OktaAuthModule, OktaCallbackComponent} from '@okta/okta-angular';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {environment} from '../environments/environment';
import {OktaAuth} from '@okta/okta-auth-js';
import {AuthOktaInterceptor} from './shared-module/http-interceptors/auth-okta.interceptor';

const config = {
  issuer: environment.issuer,
  clientId: environment.clientId,
  redirectUri: window.location.origin + '/implicit/callback',
  pkce: true,
  scopes: ['openid', 'email', 'profile', 'address', 'phone', 'offline_access']
};
const oktaAuth = new OktaAuth(config);

const routes: Routes = [
  {
    path: 'implicit/callback',
    component: OktaCallbackComponent
  },
  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    OktaAuthModule,
    RouterModule.forRoot(routes)
  ],
  providers: [
    {provide: OKTA_CONFIG, useValue: { oktaAuth } },
    {provide: HTTP_INTERCEPTORS, useClass: AuthOktaInterceptor, multi: true}
  ],
  exports: [RouterModule]
})
export class AuthRoutingModule {
}
